import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="copyright">
        <p>© 2023 Une management. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
